import { cabinetApi as api } from "../api";
export const addTagTypes = ["api", "AppNotification"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      notificationsAnswerSubscriptionsCreate: build.mutation<
        NotificationsAnswerSubscriptionsCreateApiResponse,
        NotificationsAnswerSubscriptionsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/notifications/answer_subscriptions/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsAnswerSubscriptionsRetrieve: build.query<
        NotificationsAnswerSubscriptionsRetrieveApiResponse,
        NotificationsAnswerSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/answer_subscriptions/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      notificationsAnswerSubscriptionsDestroy: build.mutation<
        NotificationsAnswerSubscriptionsDestroyApiResponse,
        NotificationsAnswerSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/answer_subscriptions/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsAppNotificationsList: build.query<
        NotificationsAppNotificationsListApiResponse,
        NotificationsAppNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/`,
          params: {
            read: queryArg.read,
            read_in: queryArg.readIn,
            read_isnull: queryArg.readIsnull,
            seen: queryArg.seen,
            seen_in: queryArg.seenIn,
            seen_isnull: queryArg.seenIsnull,
            type: queryArg["type"],
            type_in: queryArg.typeIn,
            type_isnull: queryArg.typeIsnull,
          },
        }),
        providesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsCreate: build.mutation<
        NotificationsAppNotificationsCreateApiResponse,
        NotificationsAppNotificationsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsRetrieve: build.query<
        NotificationsAppNotificationsRetrieveApiResponse,
        NotificationsAppNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/${queryArg}/`,
        }),
        providesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsUpdate: build.mutation<
        NotificationsAppNotificationsUpdateApiResponse,
        NotificationsAppNotificationsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.appNotificationRequest,
        }),
        invalidatesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsPartialUpdate: build.mutation<
        NotificationsAppNotificationsPartialUpdateApiResponse,
        NotificationsAppNotificationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedAppNotification,
        }),
        invalidatesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsDestroy: build.mutation<
        NotificationsAppNotificationsDestroyApiResponse,
        NotificationsAppNotificationsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["AppNotification"],
      }),
      notificationsAppNotificationsCountUnreadAppNotificationsRetrieve:
        build.query<
          NotificationsAppNotificationsCountUnreadAppNotificationsRetrieveApiResponse,
          NotificationsAppNotificationsCountUnreadAppNotificationsRetrieveApiArg
        >({
          query: () => ({
            url: `/api/v1_15/notifications/app-notifications/count-unread-app-notifications/`,
          }),
          providesTags: ["AppNotification"],
        }),
      notificationsAppNotificationsMarkAllSeenPartialUpdate: build.mutation<
        NotificationsAppNotificationsMarkAllSeenPartialUpdateApiResponse,
        NotificationsAppNotificationsMarkAllSeenPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/app-notifications/mark-all-seen/`,
          method: "PATCH",
          body: queryArg,
        }),
        invalidatesTags: ["AppNotification"],
      }),
      notificationsNotificationsList: build.query<
        NotificationsNotificationsListApiResponse,
        NotificationsNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      notificationsNotificationsCreate: build.mutation<
        NotificationsNotificationsCreateApiResponse,
        NotificationsNotificationsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      notificationsNotificationsRetrieve: build.query<
        NotificationsNotificationsRetrieveApiResponse,
        NotificationsNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      notificationsNotificationsUpdate: build.mutation<
        NotificationsNotificationsUpdateApiResponse,
        NotificationsNotificationsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.questionNotificationRequest,
        }),
        invalidatesTags: ["api"],
      }),
      notificationsNotificationsPartialUpdate: build.mutation<
        NotificationsNotificationsPartialUpdateApiResponse,
        NotificationsNotificationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedQuestionNotification,
        }),
        invalidatesTags: ["api"],
      }),
      notificationsNotificationsDestroy: build.mutation<
        NotificationsNotificationsDestroyApiResponse,
        NotificationsNotificationsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsNotificationsCountRetrieve: build.query<
        NotificationsNotificationsCountRetrieveApiResponse,
        NotificationsNotificationsCountRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/notifications/notifications/count/` }),
        providesTags: ["api"],
      }),
      notificationsNotificationsReadPartialUpdate: build.mutation<
        NotificationsNotificationsReadPartialUpdateApiResponse,
        NotificationsNotificationsReadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/read/`,
          method: "PATCH",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      notificationsNotificationsSeePartialUpdate: build.mutation<
        NotificationsNotificationsSeePartialUpdateApiResponse,
        NotificationsNotificationsSeePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/notifications/see/`,
          method: "PATCH",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      notificationsQuestionSubscriptionsCreate: build.mutation<
        NotificationsQuestionSubscriptionsCreateApiResponse,
        NotificationsQuestionSubscriptionsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/notifications/question_subscriptions/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsQuestionSubscriptionsRetrieve: build.query<
        NotificationsQuestionSubscriptionsRetrieveApiResponse,
        NotificationsQuestionSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/question_subscriptions/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      notificationsQuestionSubscriptionsDestroy: build.mutation<
        NotificationsQuestionSubscriptionsDestroyApiResponse,
        NotificationsQuestionSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/question_subscriptions/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsResourceResponseSubscriptionsCreate: build.mutation<
        NotificationsResourceResponseSubscriptionsCreateApiResponse,
        NotificationsResourceResponseSubscriptionsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/notifications/resource_response_subscriptions/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsResourceResponseSubscriptionsRetrieve: build.query<
        NotificationsResourceResponseSubscriptionsRetrieveApiResponse,
        NotificationsResourceResponseSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/resource_response_subscriptions/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      notificationsResourceResponseSubscriptionsDestroy: build.mutation<
        NotificationsResourceResponseSubscriptionsDestroyApiResponse,
        NotificationsResourceResponseSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/resource_response_subscriptions/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsResourceSubscriptionsCreate: build.mutation<
        NotificationsResourceSubscriptionsCreateApiResponse,
        NotificationsResourceSubscriptionsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/notifications/resource_subscriptions/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      notificationsResourceSubscriptionsRetrieve: build.query<
        NotificationsResourceSubscriptionsRetrieveApiResponse,
        NotificationsResourceSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/resource_subscriptions/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      notificationsResourceSubscriptionsDestroy: build.mutation<
        NotificationsResourceSubscriptionsDestroyApiResponse,
        NotificationsResourceSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/notifications/resource_subscriptions/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as notificationsGenerated };
export type NotificationsAnswerSubscriptionsCreateApiResponse = unknown;
export type NotificationsAnswerSubscriptionsCreateApiArg = void;
export type NotificationsAnswerSubscriptionsRetrieveApiResponse = unknown;
export type NotificationsAnswerSubscriptionsRetrieveApiArg = string;
export type NotificationsAnswerSubscriptionsDestroyApiResponse = unknown;
export type NotificationsAnswerSubscriptionsDestroyApiArg = string;
export type NotificationsAppNotificationsListApiResponse =
  /** status 200  */ AppNotification[];
export type NotificationsAppNotificationsListApiArg = {
  read?: boolean;
  /** read (in) */
  readIn?: string;
  /** read (is null) */
  readIsnull?: boolean;
  seen?: boolean;
  /** seen (in) */
  seenIn?: string;
  /** seen (is null) */
  seenIsnull?: boolean;
  /** * `CADENCE_REMINDER` - CADENCE_REMINDER
   * `CONTACT_TASK_DUE` - CONTACT_TASK_DUE
   * `MEETING_LINK` - MEETING_LINK */
  type?: "CADENCE_REMINDER" | "CONTACT_TASK_DUE" | "MEETING_LINK";
  /** type (in) */
  typeIn?: string;
  /** type (is null) */
  typeIsnull?: boolean;
};
export type NotificationsAppNotificationsCreateApiResponse =
  /** status 201  */ AppNotification;
export type NotificationsAppNotificationsCreateApiArg = AppNotificationRequest;
export type NotificationsAppNotificationsRetrieveApiResponse =
  /** status 200  */ AppNotification;
export type NotificationsAppNotificationsRetrieveApiArg =
  /** A unique integer value identifying this app notification. */ number;
export type NotificationsAppNotificationsUpdateApiResponse =
  /** status 200  */ AppNotification;
export type NotificationsAppNotificationsUpdateApiArg = {
  /** A unique integer value identifying this app notification. */
  id: number;
  appNotificationRequest: AppNotificationRequest;
};
export type NotificationsAppNotificationsPartialUpdateApiResponse =
  /** status 200  */ AppNotification;
export type NotificationsAppNotificationsPartialUpdateApiArg = {
  /** A unique integer value identifying this app notification. */
  id: number;
  patchedAppNotification: PatchedAppNotification;
};
export type NotificationsAppNotificationsDestroyApiResponse = unknown;
export type NotificationsAppNotificationsDestroyApiArg =
  /** A unique integer value identifying this app notification. */ number;
export type NotificationsAppNotificationsCountUnreadAppNotificationsRetrieveApiResponse =
  /** status 200  */ CountUnreadAppNotifications;
export type NotificationsAppNotificationsCountUnreadAppNotificationsRetrieveApiArg =
  void;
export type NotificationsAppNotificationsMarkAllSeenPartialUpdateApiResponse =
  /** status 200  */ AppNotification;
export type NotificationsAppNotificationsMarkAllSeenPartialUpdateApiArg =
  PatchedAppNotification;
export type NotificationsNotificationsListApiResponse =
  /** status 200  */ PaginatedQuestionNotificationList;
export type NotificationsNotificationsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type NotificationsNotificationsCreateApiResponse =
  /** status 201  */ QuestionNotification;
export type NotificationsNotificationsCreateApiArg =
  QuestionNotificationRequest;
export type NotificationsNotificationsRetrieveApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsRetrieveApiArg =
  /** A unique integer value identifying this Notification. */ number;
export type NotificationsNotificationsUpdateApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsUpdateApiArg = {
  /** A unique integer value identifying this Notification. */
  id: number;
  questionNotificationRequest: QuestionNotificationRequest;
};
export type NotificationsNotificationsPartialUpdateApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsPartialUpdateApiArg = {
  /** A unique integer value identifying this Notification. */
  id: number;
  patchedQuestionNotification: PatchedQuestionNotification;
};
export type NotificationsNotificationsDestroyApiResponse = unknown;
export type NotificationsNotificationsDestroyApiArg =
  /** A unique integer value identifying this Notification. */ number;
export type NotificationsNotificationsCountRetrieveApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsCountRetrieveApiArg = void;
export type NotificationsNotificationsReadPartialUpdateApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsReadPartialUpdateApiArg =
  PatchedQuestionNotification;
export type NotificationsNotificationsSeePartialUpdateApiResponse =
  /** status 200  */ QuestionNotification;
export type NotificationsNotificationsSeePartialUpdateApiArg =
  PatchedQuestionNotification;
export type NotificationsQuestionSubscriptionsCreateApiResponse = unknown;
export type NotificationsQuestionSubscriptionsCreateApiArg = void;
export type NotificationsQuestionSubscriptionsRetrieveApiResponse = unknown;
export type NotificationsQuestionSubscriptionsRetrieveApiArg = string;
export type NotificationsQuestionSubscriptionsDestroyApiResponse = unknown;
export type NotificationsQuestionSubscriptionsDestroyApiArg = string;
export type NotificationsResourceResponseSubscriptionsCreateApiResponse =
  unknown;
export type NotificationsResourceResponseSubscriptionsCreateApiArg = void;
export type NotificationsResourceResponseSubscriptionsRetrieveApiResponse =
  unknown;
export type NotificationsResourceResponseSubscriptionsRetrieveApiArg = string;
export type NotificationsResourceResponseSubscriptionsDestroyApiResponse =
  unknown;
export type NotificationsResourceResponseSubscriptionsDestroyApiArg = string;
export type NotificationsResourceSubscriptionsCreateApiResponse = unknown;
export type NotificationsResourceSubscriptionsCreateApiArg = void;
export type NotificationsResourceSubscriptionsRetrieveApiResponse = unknown;
export type NotificationsResourceSubscriptionsRetrieveApiArg = string;
export type NotificationsResourceSubscriptionsDestroyApiResponse = unknown;
export type NotificationsResourceSubscriptionsDestroyApiArg = string;
export type PicUrl = {
  pic_url: string | null;
};
export type UserRealName = {
  id: number;
  first_name: string;
  last_name: string;
  profile: PicUrl;
  email: string;
};
export type AppNotification = {
  id: number;
  user: UserRealName;
  /** Serialize the generic foreign key content object. */
  resource: {
    id: number;
    type: string;
    str: string;
  } | null;
  type_display: string;
  created_at: string;
  updated_at: string;
  /** * `CADENCE_REMINDER` - CADENCE_REMINDER
   * `CONTACT_TASK_DUE` - CONTACT_TASK_DUE
   * `MEETING_LINK` - MEETING_LINK */
  type: "CADENCE_REMINDER" | "CONTACT_TASK_DUE" | "MEETING_LINK" | "MEETING_FOLLOW_UP";
  object_id: number | null;
  read_date: string | null;
  read: boolean;
  seen: boolean;
  title: string;
  body: string;
  meta: any | null;
  content_type: number | null;
};
export type AppNotificationRequest = {
  created_at?: string;
  /** * `CADENCE_REMINDER` - CADENCE_REMINDER
   * `CONTACT_TASK_DUE` - CONTACT_TASK_DUE
   * `MEETING_LINK` - MEETING_LINK */
  type: "CADENCE_REMINDER" | "CONTACT_TASK_DUE" | "MEETING_LINK" | "MEETING_FOLLOW_UP";
  object_id?: number | null;
  read_date?: string | null;
  read?: boolean;
  seen?: boolean;
  title: string;
  body: string;
  meta?: any | null;
  content_type?: number | null;
};
export type PatchedAppNotification = {
  created_at?: string;
  /** * `CADENCE_REMINDER` - CADENCE_REMINDER
   * `CONTACT_TASK_DUE` - CONTACT_TASK_DUE
   * `MEETING_LINK` - MEETING_LINK */
  type?: "CADENCE_REMINDER" | "CONTACT_TASK_DUE" | "MEETING_LINK" | "MEETING_FOLLOW_UP";
  object_id?: number | null;
  read_date?: string | null;
  read?: boolean;
  seen?: boolean;
  title?: string;
  body?: string;
  meta?: any | null;
  content_type?: number | null;
};
export type CountUnreadAppNotifications = {
  count: number;
};
export type MiniQuestion = {
  id: number;
  title: string;
  tag_list: string[];
  create_date: string;
  categories_list: string[];
  num_answers: number;
  last_answer_date: string | null;
};
export type MiniAnswer = {
  id: number;
  question: number | null;
  create_date: string;
};
export type QuestionNotification = {
  id: number;
  user: UserRealName;
  create_date: string;
  unread: boolean;
  action: string | null;
  user_a: UserRealName | null;
  user_b: UserRealName | null;
  question: MiniQuestion;
  answer: MiniAnswer;
};
export type PaginatedQuestionNotificationList = {
  data: QuestionNotification[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type TagRequest = {
  name: string;
  color: string;
};
export type MiniQuestionRequest = {
  tags?: TagRequest[];
};
export type QuestionNotificationRequest = {
  action: string | null;
  question: MiniQuestionRequest;
};
export type PatchedQuestionNotification = {
  action?: string | null;
  question?: MiniQuestionRequest;
};
export const {
  useNotificationsAnswerSubscriptionsCreateMutation,
  useNotificationsAnswerSubscriptionsRetrieveQuery,
  useNotificationsAnswerSubscriptionsDestroyMutation,
  useNotificationsAppNotificationsListQuery,
  useNotificationsAppNotificationsCreateMutation,
  useNotificationsAppNotificationsRetrieveQuery,
  useNotificationsAppNotificationsUpdateMutation,
  useNotificationsAppNotificationsPartialUpdateMutation,
  useNotificationsAppNotificationsDestroyMutation,
  useNotificationsAppNotificationsCountUnreadAppNotificationsRetrieveQuery,
  useNotificationsAppNotificationsMarkAllSeenPartialUpdateMutation,
  useNotificationsNotificationsListQuery,
  useNotificationsNotificationsCreateMutation,
  useNotificationsNotificationsRetrieveQuery,
  useNotificationsNotificationsUpdateMutation,
  useNotificationsNotificationsPartialUpdateMutation,
  useNotificationsNotificationsDestroyMutation,
  useNotificationsNotificationsCountRetrieveQuery,
  useNotificationsNotificationsReadPartialUpdateMutation,
  useNotificationsNotificationsSeePartialUpdateMutation,
  useNotificationsQuestionSubscriptionsCreateMutation,
  useNotificationsQuestionSubscriptionsRetrieveQuery,
  useNotificationsQuestionSubscriptionsDestroyMutation,
  useNotificationsResourceResponseSubscriptionsCreateMutation,
  useNotificationsResourceResponseSubscriptionsRetrieveQuery,
  useNotificationsResourceResponseSubscriptionsDestroyMutation,
  useNotificationsResourceSubscriptionsCreateMutation,
  useNotificationsResourceSubscriptionsRetrieveQuery,
  useNotificationsResourceSubscriptionsDestroyMutation,
} = injectedRtkApi;
